import { h, Component } from "preact";
import { Text } from "preact-i18n";

class Video extends Component {
  render() {

    const { video } = this.props;

    /*
<iframe width="560" height="315" src="https://www.youtube.com/embed/y3BHmwN6t6k" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      <iframe src={video} allow="autoplay;"
        allowfullscreen="allowfullscreen" width="640" height="480" frameborder="0"
      >
          </iframe>

*/

    return (
      <div>
        <div >
          <div id={this.props.id} class="uk-container">
            <h2 class="uk-h1 uk-margin-top uk-width-xlarge uk-margin-auto uk-text-center uk-margin-large-bottom">
              <Text id="Video.title">Conteúdos</Text>
            </h2>
          </div>
          <div style={{marginLeft:"21em"}}>
          <h4>
          <Text id="Video.subtitle1">1 – Introdução à “Agricultura inteligente” – “Do campo ao prato”</Text>
          </h4>
          
          <h4>
          <Text id="Video.subtitle2">2 – Objetivos da futura PAC e seus impactos na atividade agrícola</Text>
          </h4>
          <h4>
          <Text id="Video.subtitle3">3 – Paisagem e biodiversidade</Text>
          </h4>
          <h4>
          <Text id="Video.subtitle4">4 – Sistemas de produção agrícola e economia circular</Text>
          </h4>
          <h4>
          <Text id="Video.subtitle5">5 – Agricultura de Precisão</Text>
          </h4>
          <h4>
          <Text id="Video.subtitle6">6 – Zootecnia de precisão</Text>
          </h4>
          <h4>
          <Text id="Video.subtitle7">7 – Neutralidade climática e ambiente.</Text>
          </h4>
          <h4>
          <Text id="Video.subtitle8">8 – Consumidores e processos de produção transparentes (rastreabilidade)</Text>
          </h4>
          <h4>
          <Text id="Video.subtitle9"></Text>
          </h4>
          </div>
        </div>

       
      </div >
    );
  }
}

export default Video;
/*
<div>
        <div class="uk-width-xlarge uk-margin-auto uk-text-center uk-margin-large-bottom">

          <h2 class="uk-h1 uk-margin-top">
            <Text id="Video.title">Como Funciona</Text>
          </h2>
          <p class="uk-text-large tm-text-large">
            <Text id="Video.subtitle">
              Assista ao vídeo do guia rápido de como deve
              utilizar a conta e suas breves funcionalidades.
            </Text>
          </p>
        </div>

        <div id={this.props.id} class="video-container">
          <iframe width="640" height="480" src={video}
            frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
          </iframe>
        </div>

      </div >
*/